import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PoliticasCredito } from '../../_models/politicas-credito';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavService } from '../../_services/_nav.service';
import { forkJoin } from 'rxjs';
import { Segmento } from '../../_models/segmento';
import { PoliticaCreditoSegmento } from '../../_models/politica-credito-segmento';
import { PoliticaCreditoSegmentoService } from '../../_services/politica-credito-segmento.service';
import { SegmentosService } from '../../_services/segmentos.service';
@Component({
  selector: 'app-politicas-credito-segmento',
  templateUrl: 'politicas-credito-segmento.component.html'
})

export class PoliticasCreditoSegmentoComponent implements OnInit{
  @Input() politica: PoliticasCredito;
  @Output() dismiss: EventEmitter<string> = new EventEmitter();
  lisSegmentos: SelectItem[] = [];
  lisSegmentosTodos: Segmento[] = [];
  carInformacionInicial = true;
  lisPoliticasSegmentos: PoliticaCreditoSegmento[] = [];
  formulario: FormGroup;
  submitted = false;
  guardando = false;
  columnas: any[];

  constructor(
    private conServicio: ConfirmationService,
    private polCreditoSegmentoService: PoliticaCreditoSegmentoService,
    private segServicio: SegmentosService,
    private nav: NavService,
    private fb: FormBuilder ) {

  }

  ngOnInit(): void {

    this.columnas = [
      { field: 'nombreSegmento', header: this.nav.buscarMensaje( 'POLITICAS.LBL_SEGMENTO' ), sort: true },
      { field: 'det', header: this.nav.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];


    forkJoin(
      this.polCreditoSegmentoService.listadoPorPolitica( this.politica.idPoliticaCredito ),
      this.segServicio.listado()
    ).subscribe( ( [ lisPoliticaSegmentos, segmentos ] ) => {
      this.lisPoliticasSegmentos = lisPoliticaSegmentos.filter( x => x.indicadorHabilitado );
      this.lisSegmentosTodos = segmentos.filter( x => x.indicadorHabilitado );
      this.cargarSegmentos();
      this.cargarFormulario();
      this.carInformacionInicial = false;

    } );


  }

  cargarSegmentos() {
    this.lisSegmentos = [];
    this.lisSegmentosTodos.map( ( segmento: Segmento ) => {
      if ( !this.lisPoliticasSegmentos.find( x => x.idSegmento === segmento.idSegmento ) ) {
        this.lisSegmentos.push( { label: segmento.nombre, value: segmento.idSegmento } );
      }
    } );
  }

  cargarFormulario() {
    this.formulario = this.fb.group( {
      idSegmentos: [ [], [ Validators.required ] ]
    } );
  }

  onSubmit() {
    this.submitted = true;
    if ( this.formulario.valid ) {
      this.guardando = true;
      const segCrear = this.formulario.value;
      let segAgregar = [];
      if ( segCrear.idSegmentos ) {
        segCrear.idSegmentos.map( s => {
          const regAgregar = {} as PoliticaCreditoSegmento;
          regAgregar.idPoliticaCredito = this.politica.idPoliticaCredito;
          regAgregar.indicadorHabilitado = true;
          regAgregar.idSegmento = s;
          segAgregar.push( regAgregar );
        } );
      }

      if ( segAgregar.length > 0 ) {
        this.polCreditoSegmentoService.bulk( segAgregar ).subscribe( segmentos => {
          segmentos.map( ( s: PoliticaCreditoSegmento ) => {
            const a = this.lisSegmentosTodos.find( x => x.idSegmento === s.idSegmento );
            if ( a ) {
              s.nombreSegmento = a.nombre;
            }
            this.lisPoliticasSegmentos = [ ...this.lisPoliticasSegmentos, s ];
          } );
          this.cargarSegmentos();
          this.formulario.reset();
          this.submitted = false;
          this.guardando = false;
          this.nav.setMesage( 1 );
        }, error => {
          this.guardando = false;
          this.nav.setMesage( 3 );
        } );
      } else {
        this.nav.setMesage( 1 );
        this.guardando = false;
      }

    }
  }

  inhabilitar( segmento: PoliticaCreditoSegmento ) {

    this.conServicio.confirm( {
      message: this.nav.buscarMensaje( 'MSG_INHABILITAR' ),
      header: this.nav.buscarMensaje( 'LBL_CONFIRMACION' ),
      icon: 'fa fa-question-circle',
      key: 'segmentos',
      accept: () => {
        this.carInformacionInicial = true;
        segmento.indicadorHabilitado = false;
        this.polCreditoSegmentoService.actualizar( segmento ).subscribe( regActualizado => {
          const a = this.lisPoliticasSegmentos.findIndex( x => x.idPoliticaCreditoSegmento === segmento.idPoliticaCreditoSegmento );
          if ( a >= 0 ) {
            this.lisPoliticasSegmentos.splice( a, 1 );
          }
          this.cargarSegmentos();
          this.carInformacionInicial = false;
        } );
      },
      reject: () => {
      }
    } );

  }


  get f() {
    return this.formulario.controls;
  }
}
